// Constant
import { ASSESSMENT_PHASES, ASSESSMENT_STATUS, ASSESSMENT_FORMS } from 'constant/shared.constant';

// Assessment Phases
const { REGISTRATION, PLANNING, PREPARATION, ASSESSMENT, DECISION } = ASSESSMENT_PHASES;

// Assessment Status
const { DRAFT } = ASSESSMENT_STATUS;

// Assessment Forms
const {
  PERSONAL_DATA,
  CERTIFICATION_DATA,
  PRECONDITION_FORM,
  SELF_ASSESSMENT,
  ANOTHER_DOCUMENT,
  PRE_ASSESSMENT,
  SCHEDULE,
  ASSESSMENT_DETAIL,
  DECISION_DETAIL,
} = ASSESSMENT_FORMS;

type TMenus = {
  assessmentPhase: ASSESSMENT_PHASES;
  forms: ASSESSMENT_FORMS[];
};

const FORMS = [
  {
    assessmentPhase: REGISTRATION,
    forms: [PERSONAL_DATA, CERTIFICATION_DATA, PRECONDITION_FORM, SELF_ASSESSMENT, ANOTHER_DOCUMENT],
  },
  {
    assessmentPhase: PLANNING,
    forms: [SCHEDULE, ANOTHER_DOCUMENT],
  },
  {
    assessmentPhase: PREPARATION,
    forms: [PRE_ASSESSMENT, ANOTHER_DOCUMENT],
  },
  {
    assessmentPhase: ASSESSMENT,
    forms: [ASSESSMENT_DETAIL],
  },
  {
    assessmentPhase: DECISION,
    forms: [DECISION_DETAIL],
  },
] as TMenus[];

/**
 * @description Find form of assessment
 *
 * @return {TMenus['forms']} TMenus['forms']
 */
export const assessmentUtils_findForm = (assessmentPhase: ASSESSMENT_PHASES): TMenus['forms'] => {
  return FORMS.find(form => form.assessmentPhase === assessmentPhase)?.forms || [];
};

/**
 * @description Check if assessment is editable
 *
 * @param {ASSESSMENT_PHASES} phase
 * @param {ASSESSMENT_STATUS} status
 * @param {object} options
 *
 * @return {boolean} boolean
 */
export const assessmentUtils_isEditable = (
  phase: ASSESSMENT_PHASES,
  status: ASSESSMENT_STATUS,
  options?: { isFirstTime?: boolean },
): boolean => {
  // Check if user still in registration and status still in draft
  if ([REGISTRATION].includes(phase) && [DRAFT].includes(status)) {
    return true;
  }

  // Check if user still in the first time when start to register certificate
  if (options?.isFirstTime && [REGISTRATION].includes(phase) && [DRAFT].includes(status)) {
    return true;
  }

  return [PREPARATION].includes(phase);
};
